import { useQuery } from '@tanstack/react-query';
import resolveApiBase from '../../tradingCockpit/apiBase';

const API_BASE = resolveApiBase();
const API_KEY = process.env.REACT_APP_API_KEY || '';
const POLL_MS = 45000;

export const EXECUTION_MODE_LIVE = 'live';
export const EXECUTION_MODE_SIMULATION = 'simulation';

const DEFAULT_FAMILIES = [
    { key: 'dhruva', label: 'Dhruva', executionMode: EXECUTION_MODE_LIVE },
    { key: 'cobra', label: 'Cobra', executionMode: EXECUTION_MODE_SIMULATION },
    { key: 'vyasa', label: 'Vyasa', executionMode: EXECUTION_MODE_SIMULATION },
    { key: 'garuda', label: 'Garuda', executionMode: EXECUTION_MODE_SIMULATION },
    { key: 'vidura', label: 'Vidura', executionMode: EXECUTION_MODE_SIMULATION },
    { key: 'chanakya', label: 'Chanakya', executionMode: EXECUTION_MODE_SIMULATION },
    { key: 'chanakya_inverse', label: 'Chanakya Inverse', executionMode: EXECUTION_MODE_SIMULATION },
    { key: 'arjuna', label: 'Arjuna', executionMode: EXECUTION_MODE_SIMULATION },
    { key: 'narasimha', label: 'Narasimha', executionMode: EXECUTION_MODE_SIMULATION },
];

const resolveUrl = (path) => {
    if (!API_BASE) {
        return path;
    }
    const normalisedBase = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
    return `${normalisedBase}${path.startsWith('/') ? path : `/${path}`}`;
};

const buildHeaders = () => {
    const headers = { Accept: 'application/json' };
    if (API_KEY) {
        headers['x-api-key'] = API_KEY;
    }
    return headers;
};

async function fetchQCockpitFamilies() {
    const response = await fetch(resolveUrl('/api/qcockpit/families'), {
        headers: buildHeaders(),
    });
    if (!response.ok) {
        const text = await response.text();
        throw new Error(`${response.status}: ${text}`);
    }
    return response.json();
}

export function filterFamiliesByMode(families, mode) {
    const targetMode = mode === EXECUTION_MODE_LIVE
        ? EXECUTION_MODE_LIVE
        : EXECUTION_MODE_SIMULATION;
    return families.filter((family) => family.executionMode === targetMode);
}

export function resolveFamilyForMode(families, mode, preferredKey, fallbackKey = 'cobra') {
    const available = filterFamiliesByMode(families, mode);
    if (!available.length) {
        return null;
    }
    if (preferredKey && available.some((family) => family.key === preferredKey)) {
        return preferredKey;
    }
    if (available.some((family) => family.key === fallbackKey)) {
        return fallbackKey;
    }
    return available[0].key;
}

export function useQCockpitFamilies() {
    return useQuery({
        queryKey: ['qcockpit', 'families'],
        queryFn: fetchQCockpitFamilies,
        staleTime: 30000,
        refetchInterval: POLL_MS,
        refetchOnWindowFocus: true,
        placeholderData: {
            updatedAt: null,
            families: DEFAULT_FAMILIES,
        },
    });
}
